import PropTypes from 'prop-types';
import React from 'react';

class MessageError extends React.Component {

  render() {
    return (
      <span className="message-error">
        <span>Not Delivered</span>
        <span onClick={this.props.handleTryAgain} className="try-again">Try again</span>
      </span>
    );
  }
}

MessageError.propTypes = {
  handleTryAgain: PropTypes.func
};

export default MessageError;



// WEBPACK FOOTER //
// ./chat-app/components/MessageError/MessageError.js